import React from "react";
import styles from "./ResizeBox.css";
import { User } from "../../models/User";
import { Fa } from "../../atoms/Icons/Fa";
import { Button } from "../../atoms/Buttons/Base";
import { Text } from "../../atoms/Text/Text";

type ResizeBoxProps = {
  isTheaterMode: boolean;
  user?: User;
  onResizeClick?: () => void;
};

export const handlerADContent = ({ isTheaterMode }: ResizeBoxProps) => {
  if (isTheaterMode) {
    const AARP: any = (window as any).AARP;
    const expandedboxSlot = document.getElementById("ad-grayarea-content");
    if (expandedboxSlot) {
      AARP.ads.loadAd("ad-grayarea-content", expandedboxSlot.dataset.adsize);
    }
  } else {
    const GoogleTags: any = (window as any).googletag;
    const slots = GoogleTags.pubads().getSlots();
    const targetSlots = slots.filter((slot: { getSlotElementId: () => string }) => slot.getSlotElementId() === "ad-grayarea-content");
    GoogleTags.destroySlots(targetSlots);
  }
};

export class ResizeBox extends React.PureComponent<ResizeBoxProps> {
  render() {
    const { isTheaterMode, user, onResizeClick } = this.props;

    return (
      <div
        className={
          isTheaterMode ? styles.unitResizeBoxExpanded : styles.unitResizeBox
        }
      >
        <div
          className={isTheaterMode && styles.adcontent}
          id="ad-grayarea-content"
          data-adsize="728x90"
        ></div>
        <ResizeButton
          data-element-description="game size button"
          aria-label="Resize Button"
          onClick={() => onResizeClick()}
          isTheaterMode={isTheaterMode}
          user={user}
        >
          <IconContainer
            color="invert"
            key={isTheaterMode ? "compress" : "expand"}
          >
            {!isTheaterMode && !user && (
              <span className={styles.loginText}>Log In</span>
            )}
            <Fa icon={isTheaterMode ? "compress" : "expand"} />
          </IconContainer>
        </ResizeButton>
      </div>
    );
  }
}

const ResizeButton = (props: any) => (
  <Button
    className={handlerResizeButtonStyle(props.isTheaterMode, props.user)}
    {...props}
  />
);

const IconContainer = (props: any) => (
  <Text className={styles.unitIconContainer} {...props} />
);

const handlerResizeButtonStyle = (isTheaterMode: boolean, user: User) => {
  if (user) {
    if (isTheaterMode) {
      return styles.unitResizeButtonExpanded;
    }
    return styles.unitResizeButton;
  }
  return styles.notLoggedResizeButton;
};
